module.exports = __webpack_public_path__ + "static/media/FileFromDocument.21c72bd7.svg";